import { WBTypography } from "@apptractive/design-system-web";
import { useTranslation } from "react-i18next";
import { PageContainer } from "../../components/PageContainer";
import { StripePlans } from "../../components/StripePlans";

const Plans = () => {
  const { t } = useTranslation();
  return (
    <PageContainer>
      <WBTypography variant="h1">
        {t("plansTitle", { ns: "common" })}
      </WBTypography>
      <StripePlans path="checkout" isOnboarding={false} />
    </PageContainer>
  );
};

export default Plans;
